import * as React from 'react';
import { DiscountTarget } from "app/pages/DiscountEditor/modules/DiscountActions";
import { DiscountActionTargetTypeEnum } from "app/shared/model";
import { FeeSelectionEditor } from "app/pages/DiscountEditor/components/FeeSelectionEditor";
import ConnectedProductSelectionEditor from 'app/pages/DiscountEditor/components/ConnectedProductSelectionEditor';
import { SelectionMap, ProductFilter } from 'app/shared/model/ProductFilter';
import { Fee } from 'app/shared/model/Fee';
import { ProductFilterAllowedOptions } from 'app/pages/DiscountEditor/components/ProductSelection';

export interface DiscountTargetEditorProps {
    discountTarget: DiscountTarget
    fees: Fee[]
    feeSelectionChanged: (fees: SelectionMap) => void
    productFilterChanged: (products: ProductFilter) => void
}

export function DiscountTargetEditor(props: DiscountTargetEditorProps) {
    return <div>
        {getEditorWidget(props)}
    </div>;
}

function getEditorWidget(props: DiscountTargetEditorProps) {
    const discountTarget = props.discountTarget;
    switch(discountTarget.type) {
        case DiscountActionTargetTypeEnum.ApplicableProducts:
            return <span>
                    This discount will apply to all the products specified in the 'Applicable Products' section
                </span>;

        case DiscountActionTargetTypeEnum.OtherProducts:
            return <div>
                <h4>Products to discount</h4>
                <ConnectedProductSelectionEditor
                    allowedFilterOption={ProductFilterAllowedOptions.DisallowAnyProduct}
                    productFilter={discountTarget.products}
                    changeProductFilter={props.productFilterChanged}
                    />
                </div>;

        case DiscountActionTargetTypeEnum.Fees:
            return <div>
                <h4>Fees to discount</h4>
                <FeeSelectionEditor
                    fees={props.fees}
                    selectedFees={discountTarget.fees}
                    feeSelectionChanged={props.feeSelectionChanged}
                    />
                </div>
    }
}
